function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Stack } from 'react-bootstrap';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import ClaimerSubmissionStatus from './ClaimerSubmissionStatus';
import ClaimerMessages from './ClaimerMessages';
import NoHmrc from './NoHmrc';
import aifSubmissionsService from '../../services/claim/aif_submissions.service';
import claimerMessagesService from '../../services/claim/claimer_messages.service';
import claimService from '@rd-web-markets/shared/dist/services/claim/claim.service';
import DataToSendToClaimer from './data_preview/DataToSendToClaimer';
const HmrcSubmission = _ref => {
  var _aifClaim$hmrc_confir, _aifReportData$errors;
  let {
    company,
    claim: propClaim,
    subsidiaryClaim
  } = _ref;
  const [aifClaim, setAifClaim] = useState(null);
  const [claim, setClaim, fetchClaim] = claimService.useFetch({
    claimId: propClaim.id,
    fetchImmediately: true
  });
  useEffect(() => {
    if (company.requires_separate_aif_submission) {
      setAifClaim(subsidiaryClaim);
    } else {
      setAifClaim(claim);
    }
  }, [claim, company.requires_separate_aif_submission, subsidiaryClaim]);
  const {
    t
  } = useTranslation();
  const [submissionStatusLoading, setSubmissionStatusLoading] = useState(true);
  const [dataToSendToClaimerLoading, setDataToSendToClaimerLoading] = useState(true);
  const [aifReportCreationString, setAifReportCreationIdString] = useState(aifClaim === null || aifClaim === void 0 ? void 0 : aifClaim.claimer_aif_report_creation_id);
  const aif_claim_type = company.requires_separate_aif_submission ? 'subsidiary_claim' : 'claim';
  const {
    submissionStatuses,
    setSubmissionStatuses,
    currentSubmissionStatus,
    setCurrentSubmissionStatus,
    fetchStatuses
  } = aifSubmissionsService.useFetchAll({
    claim: aifClaim,
    setLoading: setSubmissionStatusLoading,
    aif_claim_type
  });
  const {
    aifReportData,
    setAifReportData,
    fetchAifReportData
  } = aifSubmissionsService.useFetchAifReportData({
    claim: aifClaim,
    setLoading: setDataToSendToClaimerLoading,
    aif_claim_type
  });
  const [claimerMessages, setClaimerMessages] = claimerMessagesService.useFetchAll({
    claimId: aifClaim === null || aifClaim === void 0 ? void 0 : aifClaim.id,
    aif_claim_type
  });
  const noSubmissionStarted = !(aifClaim !== null && aifClaim !== void 0 && aifClaim.claimer_aif_report_creation_id);
  const submissionIsDoneOrCancelled = ['submitted', 'cancelled', 'error', undefined].includes(currentSubmissionStatus === null || currentSubmissionStatus === void 0 ? void 0 : currentSubmissionStatus.status);
  const canSubmitAif = noSubmissionStarted || submissionIsDoneOrCancelled;
  const onAifSubmisison = useCallback(async () => {
    await fetchClaim();
    await fetchStatuses();
    setCurrentSubmissionStatus(currentSubmissionStatus => _objectSpread(_objectSpread({}, currentSubmissionStatus), {}, {
      status: 'awaiting_approval'
    }));
  }, [fetchClaim, fetchStatuses, setCurrentSubmissionStatus]);
  if (!aifClaim) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (submissionStatusLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-center my-4"
    }, /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement("div", {
      className: "mt-2"
    }, t('loading_claim_aif_status')));
  }
  const hmrcConfirmationPdfLink = aifClaim !== null && aifClaim !== void 0 && aifClaim.hmrc_confirmation_pdf ? /*#__PURE__*/React.createElement("a", {
    href: aifClaim === null || aifClaim === void 0 ? void 0 : aifClaim.hmrc_confirmation_pdf.url,
    target: "_blank",
    rel: "noreferrer"
  }, aifClaim === null || aifClaim === void 0 ? void 0 : aifClaim.hmrc_confirmation_pdf.filename) : /*#__PURE__*/React.createElement("p", null, t('no_file_has_been_uploaded'));
  return /*#__PURE__*/React.createElement("div", {
    className: "border rounded p-3 bg-white"
  }, /*#__PURE__*/React.createElement(Stack, {
    gap: 3
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('aif_submission_status')), /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement(ClaimerSubmissionStatus, {
    claim: aifClaim,
    status: currentSubmissionStatus === null || currentSubmissionStatus === void 0 ? void 0 : currentSubmissionStatus.status
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('hmrc_confirmation_id')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, (currentSubmissionStatus === null || currentSubmissionStatus === void 0 ? void 0 : currentSubmissionStatus.status) === 'submitted' && aifClaim.claimer_aif_hmrc_confirmation_id ? aifClaim.claimer_aif_hmrc_confirmation_id : t('aif_not_yet_confirmed_by_hmrc'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('hmrc_confirmation_document')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, (currentSubmissionStatus === null || currentSubmissionStatus === void 0 ? void 0 : currentSubmissionStatus.status) === 'submitted' && (_aifClaim$hmrc_confir = aifClaim.hmrc_confirmation_pdf) !== null && _aifClaim$hmrc_confir !== void 0 && _aifClaim$hmrc_confir.url ? hmrcConfirmationPdfLink : t('hmrc_confirmation_document_not_received_yet'))), aifReportCreationString && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('claimer_creation_id')), /*#__PURE__*/React.createElement(Col, {
    xs: 8,
    className: "fw-semibold"
  }, aifReportCreationString)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, t('claimer_messages')), /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement(ClaimerMessages, {
    claimerMessages: claimerMessages
  })))), canSubmitAif && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12
  }, /*#__PURE__*/React.createElement(NoHmrc, {
    loading: submissionStatusLoading,
    setLoading: setSubmissionStatusLoading,
    claimId: aifClaim === null || aifClaim === void 0 ? void 0 : aifClaim.id,
    isFisrstSubmission: noSubmissionStarted,
    setAifReportCreationIdString: setAifReportCreationIdString,
    onAifSubmission: onAifSubmisison,
    aif_claim_type: aif_claim_type,
    disabled: (aifReportData === null || aifReportData === void 0 || (_aifReportData$errors = aifReportData.errors) === null || _aifReportData$errors === void 0 ? void 0 : _aifReportData$errors.length) > 0
  }))), /*#__PURE__*/React.createElement("div", null, dataToSendToClaimerLoading && /*#__PURE__*/React.createElement(Loader, null), !dataToSendToClaimerLoading && /*#__PURE__*/React.createElement(DataToSendToClaimer, {
    aifReportData: aifReportData
  }))));
};
export default HmrcSubmission;